import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import FormForgotPassword from '../Form/FormForgotPassword';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { useStoreHook } from '../../Hooks/StoreHook';
import { TbLock } from 'react-icons/tb';

const ForgotPassword = () => {
    const { t } = useTranslation();
    const { company } = useLayoutContext();
    const { loadCompanyInfo } = useStoreHook();

    useEffect(() => {
        if (!company) {
            loadCompanyInfo();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <section className='h-full flex flex-col items-center justify-center p-4 pt-6 gap-6'>

            <div className='flex flex-col items-center gap-3 text-center relative z-10'>
                <TbLock size={45} className="animate-fade-in shrink-0" />

                <div className='flex flex-col gap-3'>
                    <h2 className="text-2xl font-extrabold leading-none">
                        {t('login.forgot_password.title')}
                    </h2>
                    <p className="text-gray-500 font-medium leading-none mx-auto mx-6 text-lg">
                        {t('login.forgot_password.description')}
                    </p>
                </div>
            </div>

            <div className='w-full'>
                <FormForgotPassword />
            </div>

        </section>
    );
};

export default ForgotPassword;